<template>
    <div>
        <div>
            <Titulo :titulo="'Informes - ' + routeName" />
        </div>
        <div class="margin-informes">
            <p class="mb-5 text-justify">
                <b>Filtro:</b> a través de esta opcíón, se puede descargar el informe de abonos con sus retribuciones
                correspondientes, en un periodo de tiempo determinado.
            </p>
            filtro
            <table-component :data="TablaAbonos.datos" :showButtonGenerar="true" filtro :showButtonBorrar="false"
                @click-event="clickEvent" :showFilterDates="true" @click-generar="generar" @click-buscar="loadData"
                :loadGenerar="loadGenerar">
                <table-column slot="label" :label="'Archivo'" v-bind:value="'nombre'"
                    :customClass="'text-center'"></table-column>
                <table-column slot="label" :label="'Usuario'" v-bind:value="'usuario'"
                    :customClass="'text-center'"></table-column>
                <table-column slot="label" :label="'Fecha de creación'" v-bind:value="'created_at'"
                    :customClass="'text-center'"></table-column>
                <table-column slot="label" :label="'Estado'" v-bind:value="'estado'"
                    :customClass="'text-center'"></table-column>
                <table-column slot="label" :label="'Descargar archivo'" :icon="'fa'">
                    <template slot="icon" :icon="'fa fa-download'" :class="'btn btn-sm btn-info'" :slug="'Descargar'"
                        :tooltip="'Descargar archivo'" :customActive="buttonsActives" :loading="false">
                    </template>
                </table-column>
            </table-component>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default{
    name: "Abonos",
    data(){
        return{
            loadGenerar:false,
            buttonsActives: ["finalizado"],
        }
    },

    components: {
        Titulo: () => import("@/containers/layout/Titulo.vue"),
        TableComponent: () => import("@/components/table/TableComponent"),
        TableColumn: () => import("@/components/table/TableColumn"),
    },
    computed:{
        ...mapGetters({
            TablaAbonos: "pages/tablaAbono",
            api: "api",
        }),
        routeName() {
            return this.$router.currentRoute.name;
        },
    },
    methods: {
        generar(event) {
            try{
                this.$store.commit("SET_LOADING", true);
                this.loadGenerar = true;
                this.$toasted.show("Generando archivo, por favor espere", {
                    theme: "toasted-primary",
                    position: "top-right",
                    duration: 10000,
                });

                // if (!event.filterTipoArchivoSelected) {
                //     event.filterTipoArchivoSelected = "csv";
                // }
                this.api
                    .post("informes/abonos", {
                        fecha_inicio: event.fecha_inicio,
                        fecha_final: event.fecha_fin,
                    })
                    .then(() => {
                        this.$store.commit("SET_LOADING", false);
                        this.loadGenerar = false;
                        this.loadData();
                    });
            }catch($e){
                this.$store.commit("SET_LOADING", false);
                this.loadGenerar = false;
            }
            this.loadGenerar = false;

        },
        loadData() {
            this.$store.dispatch("pages/fetchAbonos", {
                endpoint: "informes/abonos",
            });
        },
        async clickEvent(data, slug) {
            switch (slug) {
                case "Descargar":
                    this.$toasted.show(
                        "Por favor espere mientras descargamos el archivo",
                        {
                        theme: "toasted-primary",
                        position: "top-center",
                        duration: 3000,
                        }
                    );

                    this.$store.commit("SET_LOADING", true);

                    let descarga = new Promise((res, rej) => {
                        this.api
                        .post("/informes/base_garantizado2/descargar", {
                            id: data.id,
                        })
                        .then((response) => {
                            res(response.data);
                        })
                        .catch((error) => {
                            rej(error);
                        });
                    });

                    descarga
                        .then((datos) => {
                        // saveAs(new Blob([datos]), data.nombre);
                        // window.location.href = `${datos}`;
                            window.open(""+datos);
                        })
                        .catch(() => {
                        let toast = this.$toasted.show(
                            "Error intentando descargar el archivo",
                            {
                            theme: "toasted-primary",
                            position: "bottom-right",
                            duration: 5001,
                            }
                        );
                        })
                        .then(() => {
                            this.$store.commit("SET_LOADING", false);
                        });
                break;
            }
            },
    },
    mounted() {
        if (!localStorage.reload_garantizados) {
            location.reload();
            localStorage.reload_garantizados = 1;
        }
        this.loadData();
        // this.$store.dispatch("pages/fetchConvenios", {
        //     endpoint: "informes/convenio",
        // });
    },
}
</script>